import Creditor from '@/views/creditor/Add.vue'

const router = {
    path: '/creditors/edit/:creditorId',
    name: 'CreditorEdit',
    component: Creditor,
    meta: {
        title: 'Edit Creditor'
    }
  };

export default router
